<div class="main-wrapper">
  <div class="container">
    <div class="row">
      <div class="float-right col-lg-12 col-md-12">
          <app-need-help class="float-right"></app-need-help>
      </div>
    </div>
    <div class="row">
      <div class="need-help-mobile-bg"></div>
    </div>
  </div>
</div>
